module.exports = __webpack_public_path__ + "img/gravier_roule_mayenne.5252b89f.jpg";